import {
	ChangeDetectionStrategy,
	Component,
	computed,
	Input,
	signal,
	WritableSignal,
} from '@angular/core';
import { IAvatarData } from '@shared/ui-components/au-round-avatar/au-round-avatar/au-round-avatar.component';
import { AuRoundAvatarComponent } from '../au-round-avatar/au-round-avatar/au-round-avatar.component';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
	selector: 'au-avatar-with-name',
	templateUrl: './avatar-with-name.component.html',
	styleUrls: ['./avatar-with-name.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [AuRoundAvatarComponent, MatTooltip],
})
export class AvatarWithNameComponent {
	@Input() set data(avatarData: Partial<IAvatarData>) {
		this.avatarData.set(avatarData);
	}
	@Input() clickable = false;
	@Input() size = 32;
	@Input() nameOnHover = false;
	@Input() tooltipPrefix = '';

	avatarData: WritableSignal<Partial<IAvatarData>> = signal(null);
	nameText = computed(() => {
		const avatar = this.avatarData();
		const fullName = avatar?.fullName;
		const firstName = avatar?.firstName;
		const lastName = avatar?.lastName;
		const name = avatar?.name;

		const nameParts = [firstName, lastName, fullName, name].filter(Boolean);
		const displayName = nameParts.join(' ');

		return `${this.tooltipPrefix} ${displayName || 'N/A'}`;
	});
}
